import { decodeBase64 } from './encode-base64';
import { AppSectionParamsDecodeError, IntegrationDataDecodeError, toError } from './errors';
export function extractIntegrationData(appSectionParams) {
  try {
    const {
      planIds,
      navigateToSectionProps,
      navigateToPageProps,
      biOptions,
      verticalStatusContent,
      ...rest
    } = appSectionParams;
    return {
      ...rest,
      navigateToPageProps: navigateToPageProps && window.atob(navigateToPageProps),
      navigateToSectionProps: navigateToSectionProps && decodeBase64(navigateToSectionProps),
      verticalStatusContent: verticalStatusContent && decodeBase64(verticalStatusContent),
      biOptions: biOptions ? decodeBase64(biOptions) : undefined,
      planIds: planIds ? planIds.split(',') : undefined
    };
  } catch (e) {
    throw new IntegrationDataDecodeError(toError(e).message);
  }
}
export function extractRestrictedPageId(appSectionParams) {
  return appSectionParams.restrictedPageId;
}
export function parseAppSectionParams(value) {
  try {
    return value ? JSON.parse(value) : {};
  } catch (e) {
    throw new AppSectionParamsDecodeError(toError(e).message);
  }
}
export function integrationDataFromQuery(query) {
  var _query$get, _query$get2, _query$get3, _query$get4, _query$get5, _query$get6, _query$get7;
  const navigateTo = (_query$get = query.get('destination')) != null ? _query$get : undefined;
  const referralInfo = (_query$get2 = query.get('referral')) != null ? _query$get2 : undefined;
  const planIds = query.get('planIds');
  return {
    title: (_query$get3 = query.get('title')) != null ? _query$get3 : undefined,
    subtitle: (_query$get4 = query.get('subtitle')) != null ? _query$get4 : undefined,
    planIds: typeof planIds === 'string' ? planIds.split(',') : undefined,
    navigateTo,
    verticalStatusContent: readVerticalStatusContent(query),
    biOptions: referralInfo ? {
      referralInfo,
      referralId: (_query$get5 = query.get('referralId')) != null ? _query$get5 : undefined
    } : undefined,
    minStartDate: (_query$get6 = query.get('minStartDate')) != null ? _query$get6 : undefined,
    maxStartDate: (_query$get7 = query.get('maxStartDate')) != null ? _query$get7 : undefined
  };
}
export function integrationDataToQuery(data) {
  const query = new URLSearchParams();
  data.planIds && query.set('planIds', data.planIds.join(','));
  data.navigateTo && query.set('destination', data.navigateTo);
  data.title && query.set('title', data.title);
  data.subtitle && query.set('subtitle', data.subtitle);
  if (data.biOptions) {
    const {
      referralInfo,
      referralId
    } = data.biOptions;
    referralInfo && query.set('referral', referralInfo);
    referralId && query.set('referralId', referralId);
  }
  data.maxStartDate && query.set('maxStartDate', data.maxStartDate);
  data.minStartDate && query.set('minStartDate', data.minStartDate);
  if (data.verticalStatusContent) {
    const {
      titleText,
      contentText,
      buttonText
    } = data.verticalStatusContent;
    titleText && query.set('thankYouTitle', titleText);
    contentText && query.set('thankYouMessage', contentText);
    buttonText && query.set('thankYouCTA', buttonText);
  }
  return query;
}
function readVerticalStatusContent(query) {
  const verticalTitleText = query.get('thankYouTitle');
  const verticalContentText = query.get('thankYouMessage');
  const verticalButtonText = query.get('thankYouCTA');
  return verticalTitleText || verticalContentText || verticalButtonText ? {
    titleText: verticalTitleText != null ? verticalTitleText : '',
    contentText: verticalContentText != null ? verticalContentText : undefined,
    buttonText: verticalButtonText != null ? verticalButtonText : ''
  } : undefined;
}
//# sourceMappingURL=integration-data.js.map